// Prior-Period Restatement Card V4 · Phase 1b: supporting documents on an adjusting entry (components/AjeAttachments.jsx), the
// new refusal codes, and the Phase 1 item 1 rename of the read-only roll-forward list — EN + AR. Merged into lib/i18n.js
// translations (big-file rule: new strings in their own file).
export const I18N_AJE_ATT = {
  en: {
    aje: {
      priorTitle: "Prior-year audit adjustments carried forward",
      att: {
        title: "Supporting documents",
        count: "{n} file(s)",
        none: "No supporting documents — optional; posting never needs one.",
        add: "Attach files",
        uploading: "Uploading…",
        remove: "Remove",
        removeConfirm: "Remove “{name}” from this entry? It goes to the recycle bin.",
        uploaded: "{n} file(s) attached",
        removed: "File removed",
        duplicate: "Possible duplicate: “{name}” uploaded {date}{ref} looks the same. The file was attached — remove it if it is a repeat.",
        duplicateRef: " on {ref}",
        voidReadOnly: "This entry is voided — its supporting documents are kept, read-only.",
        lockedReadOnly: "The engagement is locked — supporting documents are read-only.",
        saveFirst: "Save the draft first to attach supporting documents.",
        hint: "PDF, images, Excel or CSV; up to 25 MB each.",
        by: "by {name}",
      },
    },
    errors: {
      AJE_ATTACHMENT_ENTRY_VOID: "This entry is voided — its supporting documents are read-only.",
      AJE_ATTACHMENT_ENTRY_NOT_FOUND: "The adjusting entry was not found in this engagement.",
    },
  },
  ar: {
    aje: {
      priorTitle: "قيود تسوية السنة السابقة المُرحَّلة",
      att: {
        title: "المستندات المؤيدة",
        count: "{n} ملف",
        none: "لا توجد مستندات مؤيدة — اختيارية؛ لا يتطلب الترحيل أي ملف.",
        add: "إرفاق ملفات",
        uploading: "جارٍ الرفع…",
        remove: "إزالة",
        removeConfirm: "إزالة «{name}» من هذا القيد؟ سينتقل إلى سلة المحذوفات.",
        uploaded: "تم إرفاق {n} ملف",
        removed: "تمت إزالة الملف",
        duplicate: "تكرار محتمل: الملف «{name}» المرفوع في {date}{ref} يبدو مماثلًا. تم إرفاق الملف — أزله إن كان مكررًا.",
        duplicateRef: " على {ref}",
        voidReadOnly: "هذا القيد مُلغى — تبقى مستنداته المؤيدة للقراءة فقط.",
        lockedReadOnly: "الارتباط مقفل — المستندات المؤيدة للقراءة فقط.",
        saveFirst: "احفظ المسودة أولًا لإرفاق المستندات المؤيدة.",
        hint: "PDF أو صور أو Excel أو CSV؛ حتى 25 ميغابايت لكل ملف.",
        by: "بواسطة {name}",
      },
    },
    errors: {
      AJE_ATTACHMENT_ENTRY_VOID: "هذا القيد مُلغى — مستنداته المؤيدة للقراءة فقط.",
      AJE_ATTACHMENT_ENTRY_NOT_FOUND: "لم يُعثر على قيد التسوية في هذا الارتباط.",
    },
  },
};

export default I18N_AJE_ATT;
